import { useEffect, useRef, useState } from 'react';
import { useWorklog } from '../state/WorklogContext';

interface Props {
  itemId: string;
}

export function CommentsSection({ itemId }: Props) {
  const { state, setComment } = useWorklog();
  const initial = state.store.comments[itemId] || '';
  const [draft, setDraft] = useState(initial);
  const [status, setStatus] = useState<'idle' | 'saving' | 'saved'>('idle');
  const saveTimer = useRef<number | null>(null);

  // Sync external changes (e.g., contract switch).
  useEffect(() => {
    setDraft(state.store.comments[itemId] || '');
  }, [itemId, state.activeContract, state.store.comments]);

  // Debounced save to localStorage. Comments are private and live only in the
  // per-contract store; there is no backend endpoint for them.
  useEffect(() => {
    if (draft === (state.store.comments[itemId] || '')) return;
    setStatus('saving');
    if (saveTimer.current) window.clearTimeout(saveTimer.current);
    saveTimer.current = window.setTimeout(() => {
      setComment(itemId, draft);
      setStatus('saved');
      window.setTimeout(() => setStatus('idle'), 1500);
    }, 400);
    return () => {
      if (saveTimer.current) window.clearTimeout(saveTimer.current);
    };
  }, [draft, itemId, state.activeContract, state.store.comments, setComment]);

  return (
    <div style={{ margin: '16px 0' }}>
      <h4>Private notes</h4>
      <textarea
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        placeholder="Private notes for this item (local only - not synced)"
        style={{
          width: '100%',
          minHeight: 80,
          padding: '8px 10px',
          background: 'var(--bg)',
          color: 'var(--text)',
          border: '1px solid var(--border)',
          borderRadius: 6,
          fontFamily: 'inherit',
          fontSize: 13,
          resize: 'vertical',
        }}
      />
      <div style={{ fontSize: 11, color: 'var(--text-mute)', marginTop: 4 }}>
        {status === 'saving' ? 'saving...'
          : status === 'saved' ? 'saved'
          : 'private; saved locally per contract'}
      </div>
    </div>
  );
}
